import { useLanguage } from "../contexts/LanguageContext";
import { APP_LANGS } from "../lib/i18n";

/** Shared pill-row language picker for the SC App + Customer App profile
 * pages. Also drives the flyer-language targeting (same `preferred_language`
 * field) and the whole app's UI text via LanguageContext. */
export default function LanguageSelector({ activeClass = "bg-[#1B5E20] text-white border-[#1B5E20]", testidPrefix = "lang" }) {
  const { lang, setLang } = useLanguage();
  return (
    <div className="flex flex-wrap gap-1.5" data-testid={`${testidPrefix}-row`}>
      {APP_LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          data-testid={`${testidPrefix}-${l.code}`}
          className={"px-3 py-1.5 rounded-full text-xs font-semibold border transition-colors " +
            (lang === l.code ? activeClass : "border-slate-200 text-slate-600 bg-white")}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
